// =MAIN NAV DROPDOWNS
// ---------------------------------------------------------------------------

const parent = document.getElementsByClassName('js__navParent');
// const parentLink = document.getElementsByClassName('lower-nav-item');
const navDropdown = document.getElementsByClassName('js__navDropdown');
// const sportNav = document.getElementsByClassName('sport-nav-arrow');
// console.log(sportNav);
// console.log(parent);
// console.log(navDropdown);
const mainNavParent = document.querySelectorAll('.js__navParent');
const mainNavDropdown = document.querySelectorAll('.js__navDropdown');
const mainArrow = document.querySelectorAll('.js__arrow');
// console.log(mainNavParent);
// console.log(mainNavDropdown);
// console.log(mainArrow);
const navBar = document.getElementsByClassName('main-navbar');
const mobileNav = document.getElementsByClassName('js__navMobile');
// console.log(mobileNav);
const mobileNavTarget = document.getElementsByClassName('navbar-links');
const navSearch = document.getElementsByClassName('js__navSearch');
const navMobileSearch = document.getElementsByClassName('js__navMobileSearch');
const navSearchTarget = document.getElementsByClassName('nav__search-wrapper');
// console.log(navSearch);
// const navParent = document.querySelector('.js__navParent');
// const navDrop = document.querySelector('.js__navDropdown');
// console.log(navParent);
// console.log(navDrop);
// const sib = getSiblings(navParent);
// const sibDD = getSiblings(navDrop);
// console.log('siblings', sib);
// console.log('siblings', sibDD);

// console.log(parent.length > 0);
if (parent.length > 0) {

    // const allParents = document.querySelectorAll('.main-nav .js__navParent');
    // const parentSib = document.querySelector('.js__navParent');
    // const siblings = getSiblings(parentSib);
    // console.log('siblings:', siblings);
    Array.from(parent).forEach((element, i) => {
    // $.each(parent, function(i) {
        // console.log(parent);
        const arrow = document.getElementsByClassName('js__arrow')[i];


        // console.log(arrow);
        // console.log(mobileNav);

        function resizeWindow() {
            if (window.innerWidth >= 1104) {
                if (navDropdown[i].classList.contains('is-open')) {
                    navDropdown[i].classList.remove('is-open');
                    navDropdown[i].classList.add('is-hidden');
                    arrow.setAttribute('aria-expanded', 'false');
                }
            }
        }
        window.addEventListener('resize', resizeWindow);



        // const toggleSecNav = () => {
        const toggleSecNav = (function() {
            if (navDropdown[i].classList.contains('is-open')) {
                // console.log(parent[i].classList.contains('is-open'));
                parent[i].classList.remove('is-open');
                // parent[i].classList.add('is-hidden');
                // parent[i].setAttribute('aria-hidden', 'true');
                navDropdown[i].classList.remove('is-open');
                navDropdown[i].classList.add('is-hidden');
                // navSearch[0].classList.remove('is-open');
                // navSearch[0].classList.add('is-hidden');
                arrow.setAttribute('aria-expanded', 'false');
                // sportNav[i].setAttribute('aria-expanded', 'false');



            } else {
                removeClass();
                closeMobileSearch()
                parent[i].classList.add('is-open');
                // parent[i].classList.remove('is-hidden');
                // parent[i].setAttribute('aria-hidden', 'false');
                navDropdown[i].classList.add('is-open');
                navDropdown[i].classList.remove('is-hidden');
                // navSearch[0].classList.add('is-open');
                // navSearch[0].classList.remove('is-hidden');
                arrow.setAttribute('aria-expanded', 'true');
                // sportNav[i].setAttribute('aria-expanded', 'true');

                // if (window.innerWidth < 1104) {
                //     if (mobileNav[0].classList.contains('is-open')) {
                //         mobileNav[0].classList.remove('is-open');
                //         mobileNavTarget[0].classList.remove('is-open');
                //         mobileNavTarget[0].classList.add('is-hidden-mobile');
                //     }
                // }

                // if (window.innerWidth < 1104) {
                //         mobileNav[0].classList.add('is-open');
                //         mobileNav[0].setAttribute('aria-expanded', 'true');
                //         mobileNavTarget[0].classList.add('is-open');
                //         mobileNavTarget[0].classList.remove('is-hidden-mobile');
                // }
            }

        });





        if(arrow) {
            arrow.addEventListener('click', () => {
                // console.log('click');
                // removeClass();
                toggleSecNav();
                // console.log('click');
            });

            arrow.addEventListener('keypress', (e) => {
                if (e.charCode === 13) {
                    toggleSecNav();
                }
            });
        }
        window.addEventListener('touchend', (event) => {
            if (event.target === arrow) {
                event.preventDefault();
                toggleSecNav();
            }
        });


    });



}

// console.log(mobileNav.length > 0);
if (mobileNav.length > 0) {
    Array.from(mobileNav).forEach((element, i) => {

        // const navSearch = document.getElementsByClassName('js__navSearch');
        // const mobileNavTarget = document.getElementsByClassName('navbar-links');

        function resizeWindow() {
            if (window.innerWidth >= 1104) {
                if (element.classList.contains('is-open')) {
                    element.classList.remove('is-open');
                    mobileNavTarget[0].classList.remove('is-open');
                    mobileNavTarget[0].classList.add('is-hidden-mobile');
                    navBar[0].classList.remove('is-open');
                }
            }

        }
        window.addEventListener('resize', resizeWindow);


        const toggleMobileNav = (function () {
            if (element.classList.contains('is-open')) {

                if (window.innerWidth < 1104) {
                    element.classList.remove('is-open');
                    mobileNavTarget[0].classList.remove('is-open');
                    mobileNavTarget[0].classList.add('is-hidden-mobile');
                    navBar[0].classList.remove('is-open');
                }

            } else {

                if (window.innerWidth < 1104) {
                    closeMobileSearch();
                    element.classList.add('is-open');
                    element.setAttribute('aria-expanded', 'true');
                    mobileNavTarget[0].classList.add('is-open');
                    mobileNavTarget[0].classList.remove('is-hidden-mobile');
                    navBar[0].classList.add('is-open');
                }
            }

        });

        // function closeMobileSearch() {
        //     if (navSearch[0].classList.contains('is-open')) {
        //         navSearch[0].classList.remove('is-open');
        //         navSearchTarget[0].classList.remove('is-open');
        //         navSearchTarget[0].classList.add('is-hidden')
        //     }
        // }

        // if(mobileNav) {
        element.addEventListener('click', () => {
            // console.log('click');
            // removeClass();
            toggleMobileNav();
            // console.log('click');
        });

        element.addEventListener('keypress', (e) => {
            if (e.charCode === 13) {
                toggleMobileNav();
            }
        });
// }
    });
}


if (navSearch.length > 0) {
    Array.from(navSearch).forEach((element, i) => {

        // const navSearchTarget = document.getElementsByClassName('nav__search-wrapper');

        function resizeWindow() {
            if (window.innerWidth >= 1104) {
                if (navSearch[i].classList.contains('is-open')) {
                    navSearch[i].classList.remove('is-open');
                    navSearchTarget[0].classList.remove('is-open');
                    navSearchTarget[0].classList.add('is-hidden')
                }
            }

        }
        window.addEventListener('resize', resizeWindow);


        const toggleNavSearch = (function () {
            if (navSearch[i].classList.contains('is-open')) {

                // if (window.innerWidth < 1104) {
                    navSearch[i].classList.remove('is-open');
                    navSearchTarget[0].classList.remove('is-open');
                    navSearchTarget[0].classList.add('is-hidden')
                // }

            } else {

                // if (window.innerWidth < 1104) {
                    removeClass();
                    closeMobileNav();
                    navSearch[i].classList.add('is-open');
                    navSearch[i].setAttribute('aria-expanded', 'true');
                    navSearchTarget[0].classList.add('is-open');
                    navSearchTarget[0].classList.remove('is-hidden');
                // }
            }

        });

        function closeMobileNav() {
            if (mobileNav[0].classList.contains('is-open')) {
                mobileNav[0].classList.remove('is-open');
                mobileNavTarget[0].classList.remove('is-open');
                mobileNavTarget[0].classList.add('is-hidden-mobile')
            }
        }

        // if(mobileNav) {
        navSearch[i].addEventListener('click', () => {
            console.log('click');
            // removeClass();
            toggleNavSearch();
            // console.log('click');
        });

        navSearch[i].addEventListener('keypress', (e) => {
            if (e.charCode === 13) {
                toggleNavSearch();
            }
        });
// }
    });
}



function removeClass() {
    for ( var i = 0; i < mainNavParent.length; i++) {
        mainNavParent[i].classList.remove('is-open');
        // mainNavParent[i].classList.add('is-hidden');
        // mainNavParent[i].setAttribute('aria-hidden', 'false');
        // console.log(mainNavParent[i].classList.remove('is-open'));
    }
    for ( var i = 0; i < mainNavDropdown.length; i++) {
        mainNavDropdown[i].classList.remove('is-open');
        mainNavDropdown[i].classList.add('is-hidden');
        // console.log(mainNavDropdown[i].classList.remove('is-open'));
    }
    for ( var i = 0; i < mainArrow.length; i++) {
        mainArrow[i].setAttribute('aria-expanded', 'false');
    }
}



function closeMobileSearch() {
    if (navSearch.length > 0) {
        if (navSearch[0].classList.contains('is-open')) {
            navSearch[0].classList.remove('is-open');
            navSearchTarget[0].classList.remove('is-open');
            navSearchTarget[0].classList.add('is-hidden')
        }
    }
}





// =SEARCH - MAIN NAV
// ---------------------------------------------------------------------------

// const searchIcon = document.getElementsByClassName('search-icon');
// const searchIconMobile = document.getElementsByClassName('search-icon-mobile');
// const searchBar = document.getElementsByClassName('search');
// const searchForm = document.getElementsByClassName('nav__search-wrapper');
// const mainNav = document.getElementsByClassName('main-nav');
// const inputBar = document.getElementsByClassName('search-form-input');

// if (searchIcon.length > 0) {
//         searchIcon[0].addEventListener('click', () => {
//             if (searchBar[0].classList.contains('is-open')) {
//                 mainNav[0].classList.remove('is-open');
//                 searchBar[0].classList.remove('is-open');
//                 searchForm[0].classList.remove('is-open');
//                 searchIcon[0].setAttribute('aria-expanded', 'false');
//                 window.onresize = windowSize;
//             } else {
//                 mainNav[0].classList.add('is-open');
//                 searchBar[0].classList.add('is-open');
//                 searchForm[0].classList.add('is-open');
//                 searchIcon[0].setAttribute('aria-expanded', 'true');
//                 inputBar[0].focus();
//             }
//
//         });
//
//         searchIcon[0].addEventListener('keypress', (e) => {
//             if (e.charCode === 13) {
//                 if (searchBar[0].classList.contains('is-open')) {
//                     mainNav[0].classList.remove('is-open');
//                     searchBar[0].classList.remove('is-open');
//                     searchForm[0].classList.remove('is-open');
//                     searchIcon[0].setAttribute('aria-expanded', 'false');
//                     window.onresize = windowSize;
//                 } else {
//                     mainNav[0].classList.add('is-open');
//                     searchBar[0].classList.add('is-open');
//                     searchForm[0].classList.add('is-open');
//                     searchIcon[0].setAttribute('aria-expanded', 'true');
//                     inputBar[0].focus();
//                 }
//             }
//         });
// }
// if (searchIconMobile.length > 0) {
//         searchIconMobile[0].addEventListener('click', () => {
//             if (searchBar[0].classList.contains('is-open')) {
//                 mainNav[0].classList.remove('is-open');
//                 searchBar[0].classList.remove('is-open');
//                 searchForm[0].classList.remove('is-open');
//                 searchIconMobile[0].setAttribute('aria-expanded', 'false');
//                 window.onresize = windowSize;
//             } else {
//                 mainNav[0].classList.add('is-open');
//                 searchBar[0].classList.add('is-open');
//                 searchForm[0].classList.add('is-open');
//                 searchIconMobile[0].setAttribute('aria-expanded', 'true');
//                 inputBar[0].focus();
//             }
//
//         });
//
//         searchIcon[0].addEventListener('keypress', (e) => {
//             if (e.charCode === 13) {
//                 if (searchBar[0].classList.contains('is-open')) {
//                     mainNav[0].classList.remove('is-open');
//                     searchBar[0].classList.remove('is-open');
//                     searchForm[0].classList.remove('is-open');
//                     searchIconMobile[0].setAttribute('aria-expanded', 'false');
//                     window.onresize = windowSize;
//                 } else {
//                     mainNav[0].classList.add('is-open');
//                     searchBar[0].classList.add('is-open');
//                     searchForm[0].classList.add('is-open');
//                     searchIconMobile[0].setAttribute('aria-expanded', 'true');
//                     inputBar[0].focus();
//                 }
//             }
//         });
// }
//
// function windowSize() {
//     if(window.innerWidth >= 768) {
//         if (searchBar[0].classList.contains('is-open')) {
//             mainNav[0].classList.remove('is-open');
//             searchBar[0].classList.remove('is-open');
//             searchForm[0].classList.remove('is-open');
//             searchIcon[0].setAttribute('aria-expanded', 'false');
//         }
//     }
// }




// =MAIN NAV DROPDOWN TABS
// ---------------------------------------------------------------------------
if (window.innerWidth >= 640) {

    const parentNodes = document.querySelectorAll(".dropdown__wrapper");

    let current = 0;

    Array.from(parentNodes).forEach(function(children){
        const navNodes = children.querySelectorAll(".dropdown__link");
        const contentNodes = children.querySelectorAll(".dropdown__content");

        // let current = 0;

        if (navNodes.length > 1) {
            const nav = Array.from(navNodes);
            const content = Array.from(contentNodes);

            nav.map((link, key) => {
                link.addEventListener('mouseover', () => {
                    if (!link.classList.contains('active')) {

                        nav.map(l => {
                            l.classList.remove('active');
                            l.setAttribute('aria-selected', 'false');
                        });
                        content.map(c => {
                            c.classList.remove('active');
                        });

                        current = key;

                        link.classList.add('active');
                        link.setAttribute('aria-selected', 'true');
                        content[key].classList.add('active');

                    }
                });
            });

        }

    }); // END forEach

}